import { NOTIFICATIONS_PAGE_SIZE } from '@/constant';
import api, { handleError } from '@/services/axiosInstance';
import { Agent } from '@/types/agents';
import {
  Notification,
  NotificationData,
  NotificationsStatusFilter,
  NotificationsUpdateStatus,
} from '@/types/notifications';

const NOTIFICATIONS_ENDPOINT =
  'https://api.vh3connect.io/api:mnlcYUPJ/notification';
const MARK_ALL_AS_READ_ENDPOINT =
  'https://api.vh3connect.io/api:mnlcYUPJ/notification/mark-all-read';
const MARK_ALL_AS_CLEARED_ENDPOINT =
  'https://api.vh3connect.io/api:mnlcYUPJ/notification/mark-all-cleared';
const BULK_UPDATE_ENDPOINT =
  'https://api.vh3connect.io/api:mnlcYUPJ/notification/bulk-update';

export const notificationsApi = {
  getNotifications: async ({
    status,
    pageParam = 1,
    agentIds,
    types,
  }: {
    status?: NotificationsStatusFilter;
    pageParam: number;
    agentIds?: Agent['id'][];
    types?: Notification['type'][];
  }): Promise<NotificationData | undefined> => {
    try {
      const { data } = await api.get<NotificationData>(NOTIFICATIONS_ENDPOINT, {
        params: {
          pageNumber: pageParam,
          pageSize: NOTIFICATIONS_PAGE_SIZE,
          status,
          agents: agentIds,
          types,
        },
      });

      return data;
    } catch (error) {
      handleError(error, 'notifications');
    }
  },

  bulkUpdate: async (
    notificationIds: string[],
    status: NotificationsUpdateStatus
  ): Promise<void> => {
    try {
      await api.patch(
        BULK_UPDATE_ENDPOINT,
        {
          notification_id: notificationIds,
          status,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {
      handleError(error, 'markAllAsRead');
    }
  },

  markAllAsRead: async (): Promise<void> => {
    try {
      await api.post(
        MARK_ALL_AS_READ_ENDPOINT,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {
      handleError(error, 'markAllAsRead');
    }
  },

  markAllAsCleared: async (): Promise<void> => {
    try {
      await api.post(
        MARK_ALL_AS_CLEARED_ENDPOINT,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {
      handleError(error, 'markAllAsRead');
    }
  },
};
